import i18n from "i18next";
import { messages } from "./languages";

const savedLanguage = localStorage.getItem('i18nextLng') || 'pt';

// Garantir que o idioma padrão seja salvo no localStorage se não existir
if (!localStorage.getItem('i18nextLng')) {
	localStorage.setItem('i18nextLng', 'pt');
}

i18n.init({
	debug: true,
	defaultNS: ["translations"],
	fallbackLng: "pt",
	ns: ["translations"],
	resources: messages,
	lng: savedLanguage,
});

export const changeLanguage = (language) => {
	i18n.changeLanguage(language);
	localStorage.setItem('i18nextLng', language);
};

export { i18n };